{
  "de": {
    "onboardingGroups": {
      "edit": {
        "heading": "Hast du über deine Einrichtung bereits Zugang zu einer Lizenzgruppe?",
        "paragraph": "Falls ja, kannst du den Zugang hier aktivieren. Den Code erhältst du von der Ansprechperson an deiner Bildungseinrichtung.",
        "skip": "Weiter ohne Code",
        "autoSubmitting": "Lizenz wird aktiviert …",
        "joined": {
          "title": "Du bist bereits einer Lizenzgruppe beigetreten",
          "next": "Weiter",
          "description": "Du bist über den Aktivierungscode der Gruppe „{group}“ der Schule „{school}“ zugeordnet. Hast du einen weiteren Code, kannst du ihn hier eingeben."
        }
      }
    }
  }
}
